import React, {useState} from "react";
import {useEffect} from "react";
import "./OrdibeheshtMainPage.scss";
import guaranteeBrand from "../../Assets/svg/medal-star1.svg";
import towentyFourHours from "../../Assets/svg/24-support1.svg";
import truck from "../../Assets/svg/truck-fast1.svg";
import cards from "../../Assets/svg/cards1.svg";
import ProductCardContainer from "../ProductCard/ProductCardContainer";
import Title from "../Title/Title";
import MainPageEmailBox from "../MainPageEmailBox/MainPageEmailBox";
import "../BlogPages/MainBlog.scss";
import BannerPics from "../BannerPics/BannerPics";
import SubHeaderMainPage from "../SubHeaderMainPage/SubHeaderMainPage";
import SupportiveNavMainPage from "../SupportiveNavMainPage/SupportiveNavMainPage";
import TwoBanners from "../TwoBanners/TwoBanners";
import GroupingSection from "./GroupingSection";
import {toast} from "react-toastify";
import axios from "axios";
import CardBlog from "../BlogPages/CardBlog";
import {Link, useNavigate} from "react-router-dom";
import {prefixUrl} from "../../Utils/utilsData";
import Loader from "../Loader/Loader";

const OrdibeheshtMainPage = () => {
  const [dataFetched, setDataFetched] = useState(false);
  const [slideImages, setSlideImages] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [data, setData] = useState([]);
  const [twoBannersData, setTwoBannersData] = useState([]);
  const [blogsItem, setBlogsItem] = useState(null);
  const [oneBannersData, setOneBannersData] = useState([]);
  const [specialProduct, setSpecialProduct] = useState([]);
  const [specialProducts, setSpecialProducts] = useState([]);
  const [foodBag, setFoodBag] = useState([]);
  const navigateTo = useNavigate();
  const supportFeatures = [
    {url: guaranteeBrand, title: "ضمانت اصل بودن کالا"},
    {url: towentyFourHours, title: "7روز هفته، 24 ساعته"},
    {url: truck, title: "امکان تحویل اکسپرس"},
    {url: cards, title: "امکان پرداخت در محل"},
  ];
  const [filters, setFilters] = useState({
    group: "",
    minPrice: 1,
    maxPrice: "",
    text: "",
    sort: "",
    inventory: false,
  });
  const [isLoad, setIsLoad] = useState(false);

  useEffect(() => {
    if (!dataFetched) {
      axios
        .get(`${prefixUrl()}/mainPage.php`)
        .then((res) => {
          if (res.data.status) {
            const backendData = res.data.data;
            // Extract data from the backend response
            const sliders = backendData.sliders;
            const groupData = backendData.groups;
            const data = backendData.data;
            const twoBannersData = backendData.twoBannersData;
            const blogs = backendData.blogs;
            const oneBannersData = backendData.oneBannersData;
            const specialProduct = backendData.specialProduct;
            const specialProducts = backendData.specialProducts;
            const foodBag = backendData.templeteCarts;
            setSlideImages(sliders);
            setGroupData(groupData);
            setData(data);
            setTwoBannersData(twoBannersData);
            setBlogsItem(blogs);
            setOneBannersData(oneBannersData);
            setSpecialProduct(specialProduct);
            setSpecialProducts(specialProducts);
            setDataFetched(true); // Mark data as fetched
            setFoodBag(foodBag);
            setIsLoad(true);
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [dataFetched]);
  const filterHandler = (name, value) => {
    setFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (name === "group") {
      // Construct the URL with the group value as a parameter
      const url = `/Group/SubGroups/${value.id}`;
      // Navigate to the constructed URL
      navigateTo(url);
      // setShowSubGroup(false);
    }
  };

  return (
    <>
      {isLoad ? (
        <div className="ordibeheshtMainPagePrntContainer__">
          <div className="ordibeheshtMainPageContainer__">
            <SubHeaderMainPage
              cardData={specialProduct}
              sliderImages={slideImages}
            />
            <SupportiveNavMainPage
              data={supportFeatures}
              oneBannersData={oneBannersData}
            />
            <GroupingSection
              groups={groupData}
              className={"grouping-category"}
              onSelect={filterHandler}
            />
            <Title
              englishTitle={""}
              title={"جدیدترین محصولات"}
            />

            <ProductCardContainer data={data} type={"half"}/>

            <TwoBanners data={twoBannersData}/>

            {specialProducts.length > 0 && (
              <>
                <Title
                  englishTitle={""}
                  title={"محصولات ویژه"}
                />
                <ProductCardContainer data={specialProducts.slice(0, 4)}/>
              </>
            )}
            <BannerPics data={foodBag}/>
          </div>
          <MainPageEmailBox/>
          <div className="ordibeheshtMainPageContainer__">
            <Title englishTitle={""} title={"بلاگ"}/>
          </div>
          <div
            className="main-blog-page"
            style={{marginBottom: 80, marginTop: 40}}
          >
            {blogsItem && (
              <Link
                to={`/DetailBlog/${blogsItem[0]?.id}`}
                className="row-top"
              >
                <div className="text-side">
                  <h5>{blogsItem[0]?.title ?? "Undefined"}</h5>
                  <h6>{blogsItem[0]?.text ?? "Undefined"}</h6>
                  <div className="data-line">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="clock 1">
                        <path
                          id="Vector"
                          d="M9.99935 18.9584C5.05768 18.9584 1.04102 14.9417 1.04102 10C1.04102 5.05835 5.05768 1.04169 9.99935 1.04169C14.941 1.04169 18.9577 5.05835 18.9577 10C18.9577 14.9417 14.941 18.9584 9.99935 18.9584ZM9.99935 2.29169C5.74935 2.29169 2.29102 5.75002 2.29102 10C2.29102 14.25 5.74935 17.7084 9.99935 17.7084C14.2493 17.7084 17.7077 14.25 17.7077 10C17.7077 5.75002 14.2493 2.29169 9.99935 2.29169Z"
                          fill="#484848"
                        />
                        <path
                          id="Vector_2"
                          d="M13.0909 13.275C12.9826 13.275 12.8742 13.25 12.7742 13.1834L10.1909 11.6417C9.54922 11.2584 9.07422 10.4167 9.07422 9.67502V6.25836C9.07422 5.9167 9.35755 5.63336 9.69922 5.63336C10.0409 5.63336 10.3242 5.9167 10.3242 6.25836V9.67502C10.3242 9.97502 10.5742 10.4167 10.8326 10.5667L13.4159 12.1084C13.7159 12.2834 13.8076 12.6667 13.6326 12.9667C13.5076 13.1667 13.2992 13.275 13.0909 13.275Z"
                          fill="#484848"
                        />
                      </g>
                    </svg>
                    <p>{blogsItem[0]?.date ?? "Undefined"}</p>
                  </div>
                </div>

                <div className="image-side">
                  <img src={blogsItem[0]?.image} alt=""/>
                </div>
              </Link>
            )}
            <div className="row-middle">
              {blogsItem &&
                blogsItem.slice(1).map((blog, index) => (
                  <CardBlog blogData={blog} key={index}/>
                ))}
            </div>
          </div>
        </div>
      ) : (
        <Loader/>
      )}
    </>
  );
};

export default OrdibeheshtMainPage;
